export const SET_ACTIVITIES = "SET_ACTIVITIES";
export const ADD_ACTIVITY = "ADD_ACTIVITY";
export const UPDATE_ACTIVITY = "UPDATE_ACTIVITY";
export const REMOVE_ACTIVITY = "REMOVE_ACTIVITY";
